import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestInProgressGuard } from '../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRoutes } from './../../guards/guard.models';
import { MainRequestsListComponent } from './../../shared/main-requests-list/main-requests-list.component';
import { LandAndBuildingRegisterDataChangesNotificationComponent } from './land-and-building-register-data-changes-notification.component';
import { LBRCNewDataChangesNotificationComponent } from './new-data-changes-notification/new-data-changes-notification.component';

const landAndBuildingRegisterDataChangesNotificationRoutes: Routes = [
  {
    path: MainRoutes.LandAndBuildingRegisterDataChangesNotificationRequest,
    component: LandAndBuildingRegisterDataChangesNotificationComponent,
    canActivate: [SessionGuard],
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: LBRCNewDataChangesNotificationComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(landAndBuildingRegisterDataChangesNotificationRoutes),
  ],
  providers: [SessionGuard, RequestInProgressGuard],
  exports: [RouterModule],
})
export class LandAndBuildingRegisterDataChangesNotificationRoutingModule {}
